import Link from 'next/link';

import * as styles from './index.module.scss';

const AboutUs = () => {
  return (
    <div className={`${styles['about-us-container']}`}>
      <div className={`container ${styles['container']}`}>
        <h1>About CallAPro.com</h1>
        <p>
          <Link href="/">CallAPro.com</Link> is a free service that helps consumers connect with a local service professional.
        </p>
        <p>
          All appliance professional&apos;s are independant and <Link href="/">CallAPro.com</Link> does not warrant or guarantee any work performed.
        </p>
        <p>It is the responsibility of the consumer to verify the qualifications, expertise or credentials of, any participating appliance professional.</p>
      </div>
    </div>
  );
};

export default AboutUs;
